import BackTop from './components/back-top';
import Button from './components/button';
import Cell from './components/cell';
import CellGroup from './components/cell-group';
import Checkbox from './components/checkbox';
import CheckboxGroup from './components/checkbox-group';
import Col from './components/col';
import Countdown from './components/countdown';
import Dialog from './components/dialog';
import Divider from './components/divider';
import Icon from './components/icon';
import Image from './components/image';
import Lazyload from './components/lazyload';
import List from './components/list';
import Loading from './components/loading';
import NavBar from './components/nav-bar';
import Overlay from './components/overlay';
import Pagination from './components/pagination';
import Panel from './components/panel';
import Popup from './components/popup';
import Row from './components/row';
import ScrollDetector from './components/scroll-detector';
import SearchBar from './components/search-bar';
import Sidebar from './components/sidebar';
import SidebarItem from './components/sidebar-item';
import Skeleton from './components/skeleton';
import Sticky from './components/sticky';
import Style from './components/style';
import Tab from './components/tab';
import Tabs from './components/tabs';
import Tag from './components/tag';
import Toast from './components/toast';
export {
    BackTop,
    Button,
    Cell,
    CellGroup,
    Checkbox,
    CheckboxGroup,
    Col,
    Countdown,
    Dialog,
    Divider,
    Icon,
    Image,
    Lazyload,
    List,
    Loading,
    NavBar,
    Overlay,
    Pagination,
    Panel,
    Popup,
    Row,
    ScrollDetector,
    SearchBar,
    Sidebar,
    SidebarItem,
    Skeleton,
    Sticky,
    Style,
    Tab,
    Tabs,
    Tag,
    Toast
};
var DefaultExport = {
    BackTop: BackTop,
    Button: Button,
    Cell: Cell,
    CellGroup: CellGroup,
    Checkbox: Checkbox,
    CheckboxGroup: CheckboxGroup,
    Col: Col,
    Countdown: Countdown,
    Dialog: Dialog,
    Divider: Divider,
    Icon: Icon,
    Image: Image,
    Lazyload: Lazyload,
    List: List,
    Loading: Loading,
    NavBar: NavBar,
    Overlay: Overlay,
    Pagination: Pagination,
    Panel: Panel,
    Popup: Popup,
    Row: Row,
    ScrollDetector: ScrollDetector,
    SearchBar: SearchBar,
    Sidebar: Sidebar,
    SidebarItem: SidebarItem,
    Skeleton: Skeleton,
    Sticky: Sticky,
    Style: Style,
    Tab: Tab,
    Tabs: Tabs,
    Tag: Tag,
    Toast: Toast
};
export default Object.assign(
    {
        version: '0.2.10',
        install: function install(Vue) {
            Object.values(DefaultExport).forEach(function(c) {
                return Vue.use(c);
            });
        }
    },
    DefaultExport
);
